
const convertGoldOzToThaiBaht = (goldOzPrice, precision=2) => {
    //32.148 Oz divided by 65.6 Gold Thai Baht = Oz/kg Unit with 99.99% purity
    const ozToThaiBaht = 0.49
    //Purity of gold is 96.5%
    const purity = 0.965
    return (goldOzPrice * ozToThaiBaht * purity).toFixed(precision)
}

export {
    convertGoldOzToThaiBaht
}